import { render, staticRenderFns } from "./BaseControl.vue?vue&type=template&id=61b8cdc6&"
import script from "./BaseControl.vue?vue&type=script&lang=js&"
export * from "./BaseControl.vue?vue&type=script&lang=js&"
import style0 from "./BaseControl.vue?vue&type=style&index=0&id=61b8cdc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports